// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-transfer .el-input__inner {\n  width: inherit;\n}", ""]);
// Exports
module.exports = exports;
